<template>
  <div id="viewRush" class="lv1Text">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/limit'}">限时抢购</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="background-color:#fff;padding:20px 0;">
      <div class="container">
        <el-row :gutter="20">
          <el-col :span="7">
            <div style="border:1px solid #ddd;padding:10px;">
              <el-image class="cover" :src="serve  + data.images" fit="cover"></el-image>
            </div>
          </el-col>
          <el-col :span="17">
            <div>
              <el-row>
                <el-col :span="14">
                  <div style="font-size:20px">{{data.title}}</div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv0Text" style="font-size:30px">&yen;{{data.rush_price}}</div>
                  <div class="lv3Text">抢购价</div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv3Text" style="font-size:30px">
                    <s>&yen;{{data.selling_price}}</s>
                  </div>
                  <div class="lv3Text">市场价</div>
                </el-col>
              </el-row>
            </div>
            <div class="lv2Text">
              <span class="lv3Text">浏览次数：</span>
              <span>{{data.views}}</span>
              <span class="lv3Text" style="margin-left:10px">销量：</span>
              <span>{{data.sell_number}}</span>
            </div>
            <div class="box">
              <div class="t1">
                <span style="margin-right:10px">限时抢购商品</span>
                <span style="margin-right:10px">距离结束还剩</span>
                <span>{{this.hour}}时 {{this.min}}分 {{this.sec}}秒</span>
              </div>
              <div style="padding:10px;">
                <div style="padding: 10px 0">
                  <span>抢购价:</span>
                  <span
                    class="lv0Text"
                    style="font-size:20px;margin-left:10px"
                  >&yen;{{data.rush_price}}</span>
                  <span class="lv3Text" style="margin-left:10px">
                    <s>&yen;{{data.selling_price}}</s>
                  </span>
                </div>
                <div style="padding: 10px 0" class="lv3Text">
                  <i class="fas fa-check-circle"></i> 服务承诺
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 正品保证
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 极速发货
                </div>
              </div>
            </div>
            <div style="margin:20px 0;">
              <el-input-number v-model="number" :min="1" :max="99" label="数量：" size="medium"></el-input-number>
            </div>
            <div>
              <el-button type="primary" class="btn" @click="buy">立即购买</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container" style="margin-top:20px;">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情">
                <div style="padding: 0 20px;margin-bottom:30px">
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>商品名称：{{data.title}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>商品规格：{{data.specification}}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>品牌：{{data.brand}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>货期：{{data.leadtime}}天</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>货号：{{data.item_no}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>产品分类：{{data.classification}}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-html="data.info"></div>
              </el-tab-pane>
              <el-tab-pane label="评价" style="padding: 20px 10px;">
                <div v-for="(item,index) of comments" :key="index" class="comment-item">
                  <div class="clear top1">
                    <div class="clear-item">
                      <img :src="item.headImg" class="avatar">
                    </div>
                    <div class="clear-item lv3Text" style="margin:0 10px;">{{item.nickname}}</div>
                    <div class="clear-item" v-if="item.rank">
                      <el-rate
                        class="ra"
                        disabled
                        :value="_.toInteger(item.rank)"
                        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      ></el-rate>
                    </div>
                  </div>
                  <el-row>
                    <el-col :span="20" :offset="4">
                      <div class="lv2Text">{{item.content}}</div>
                      <div
                        class="lv3Text"
                        style="font-size:12px;margin:10px 0 5px 0;"
                      >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
                    </el-col>
                  </el-row>
                </div>
                <div class="pager" align="center">
                  <el-pagination
                    @current-change="pageChange"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="10"
                  ></el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="hot" align="center">
            <div class="t2">热销榜</div>
            <div v-for="(item,index) in hot" :key="index" class="hot-item">
              <img :src=" serve + '/'+item.images" class="cover2">
              <router-link :to="'/view?id='+item.id">
                <div style="margin:10px 0;" class="title">
                  {{_.truncate(item.title, {
                  'length': 17
                  })
                  }}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: {},
      number: 1,
      page: 1,
      comments: {},
      total: 0,
      hot: {},
      min: 0,
      sec: 0,
      hour: 0
    };
  },
  watch: {
    $route: "initData"
  },
  created() {
    this.initData();
  },
  methods: {
    buy() {
      if (this.$store.state.isLogin) {
        this.$router.push({
          path: "user/order2",
          query: {
            id: this.data.product_id,
            title: encodeURIComponent(this.data.title),
            item_no: this.data.item_no,
            number: this.number,
            images: this.data.images,
            price: this.data.rush_price,
            r_id: this.id
          }
        });
      } else {
        this.$router.push("/login");
      }
    },
    pageChange(v) {
      this.page = v;
      this.axios
        .get(this.serve + "/get_product_comment", {
          params: {
            product_id: this.data.product_id,
            page: this.page
          }
        })
        .then(res => {
          this.comments = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/rush_product_info", {
          params: {
            r_id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data;
          var today = new Date();
          var year = today.getFullYear();
          var month = today.getMonth() + 1;
          var day = today.getDate();
          var endstamp = Date.parse(
            new Date(
              year + "-" + month + "-" + day + " " + this.data.end_date + ":00"
            )
          );
          var timestamp = Date.parse(new Date());
          var diff = endstamp - timestamp;
          this.hour = _.floor(diff / 1000 / 3600);
          this.min = _.floor(diff / 1000 / 60) - this.hour * 60;
          this.sec = diff % 60;
          var that = this;
          setInterval(function() {
            if (that.sec - 1 >= 0) {
              that.sec--;
            } else {
              that.sec = 59;
              if (that.min - 1 >= 0) {
                that.min--;
              } else {
                that.min = 59;
                if (that.hour - 1 >= 0) {
                  that.hour--;
                } else {
                  that.hour = 59;
                }
              }
            }
          }, 1000);
          this.axios
            .get(this.serve + "/get_product_comment", {
              params: {
                product_id: this.data.product_id,
                page: this.page
              }
            })
            .then(res => {
              this.comments = res.data.data.results;
              this.total = res.data.data.total;
            });
        });

      this.axios.get(this.serve + "/product_info_hot").then(res => {
        this.hot = res.data.data;
      });
    }
  }
};
</script>
<style lang="scss">
#viewRush {
  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50px;
  }
  .t2 {
    text-align: center;
    padding: 10px 0;
    background-color: #eee;
    margin-bottom: 20px;
  }
  .cover2 {
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .hot {
    background-color: #fff;
    border: 1px solid #ddd;
    .title:hover {
      text-decoration: underline;
    }
  }
  .hot-item {
    width: 90%;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }
  .r2 {
    padding-right: 30px;
  }
  .r1 {
    padding: 10px 0;
    border-bottom: 2px dashed #ddd;
  }
  .comment-item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .btn {
    width: 150px;
    margin-right: 50px;
  }
  .box {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    margin-top: 20px;
    width: 80%;
    .t1 {
      background-color: #e36844;
      color: #fff;
      padding: 10px;
    }
  }
  padding: 0 0 50px 0;
  .cover {
    height: 315px;
    width: 315px;
    background-position: center;
    background-size: 100% auto;
  }
}
</style>